import { useEffect } from "react";
import { getCurrentStepAPI } from "../../services/guestUsers/guestUserAllAPIService";
import { GUEST_TOKEN_KEY } from "../../common/authSession";
import { guestEnrollmentPathFromStep } from "../../common/guestEnrollmentFlow";

function readEnrollmentCurrentStep(payload) {
  if (!payload || typeof payload !== "object") return undefined;
  const candidates = [
    payload.currentStep,
    payload.CurrentStep,
    payload?.data?.currentStep,
    payload?.data?.CurrentStep,
    payload?.data?.data?.currentStep,
    payload?.data?.data?.CurrentStep,
  ];
  for (const candidate of candidates) {
    if (
      candidate !== undefined &&
      candidate !== null &&
      String(candidate).trim() !== ""
    ) {
      return String(candidate).trim();
    }
  }
  return undefined;
}

const AppStoreRedirect = () => {
  useEffect(() => {
    let active = true;

    const redirectToGuestWebFlow = async () => {
      const guestToken = localStorage.getItem(GUEST_TOKEN_KEY);
      if (!guestToken) {
        window.location.replace("/");
        return;
      }

      try {
        const response = await getCurrentStepAPI({});
        if (!active) return;
        const currentStep = readEnrollmentCurrentStep(response);
        const route = guestEnrollmentPathFromStep(currentStep);
        window.location.replace(route);
      } catch {
        if (!active) return;
        window.location.replace("/");
      }
    };

    redirectToGuestWebFlow();

    return () => {
      active = false;
    };
  }, []);

  return <div className="text-center mt-40">Redirecting...</div>;
};

export default AppStoreRedirect;
